export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-primary-100 mx-auto mb-6">
            <i className="ri-mail-send-line text-2xl text-primary-500"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm text-foreground-600 leading-relaxed mb-8">
            如果你有好看的动漫推荐、追更建议或合作意向，欢迎随时联系我们。樱花动漫之家期待你的声音，让我们一起打造更好的追更动漫平台。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#about"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-chat-smile-2-line text-lg"></i>
              投稿推荐番剧
            </a>
            <a
              href="#about"
              className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-800 rounded-full font-medium text-sm hover:bg-background-200 transition-colors border border-background-300/60 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-team-line text-lg"></i>
              商务合作咨询
            </a>
          </div>
          <div className="mt-8 pt-6 border-t border-background-200/70 flex flex-wrap items-center justify-center gap-6">
            <span className="text-xs text-foreground-500 flex items-center gap-1.5">
              <i className="ri-mail-line text-primary-500"></i>
              contact@sakura-anime.com
            </span>
            <span className="text-xs text-foreground-500 flex items-center gap-1.5">
              <i className="ri-wechat-line text-primary-500"></i>
              微信公众号：樱花动漫之家
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}